"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConditionField = exports.ConditionOperator = void 0;
var ConditionOperator;
(function (ConditionOperator) {
  ConditionOperator["GREATER_THAN"] = "greaterThan";
  ConditionOperator["LESS_THAN"] = "lessThan";
  ConditionOperator["INCLUDES_ANY_OF"] = "includesAnyOf";
  ConditionOperator["NOT_INCLUDES_ANY_OF"] = "notIncludesAnyOf";
  ConditionOperator["IS"] = "is";
  ConditionOperator["NOT_IS"] = "notIs";
  ConditionOperator["IS_ANY_OF"] = "isAnyOf";
  ConditionOperator["NOT_IS_ANY_OF"] = "notIsAnyOf";
  ConditionOperator["IS_BETWEEN"] = "isBetween";
  ConditionOperator["IS_AVAILABLE"] = "isAvailable";
  ConditionOperator["IS_NOT_AVAILABLE"] = "isNotAvailable";
  ConditionOperator["IS_MATCH"] = "isMatch";
  ConditionOperator["IS_IN_WATCHLIST"] = "isInWatchlist";
  ConditionOperator["NOT_IS_IN_WATCHLIST"] = "notIsInWatchlist";
  ConditionOperator["IS_WATCHLIST_VALUE_NULL"] = "isWatchlistValueNull";
  ConditionOperator["NOT_IS_WATCHLIST_VALUE_NULL"] = "notIsWatchlistValueNull";
  ConditionOperator["NOT_INTERSECTION_EMPTY"] = "notIntersectionEmpty";
  ConditionOperator["INTERSECTION_EMPTY"] = "intersectionEmpty";
  ConditionOperator["STARTS_WITH"] = "startsWith";
  ConditionOperator["EQUALS"] = "equals";
  ConditionOperator["NOT_EQUALS"] = "notEquals";
})(ConditionOperator = exports.ConditionOperator || (exports.ConditionOperator = {}));
var ConditionField;
(function (ConditionField) {
  ConditionField["TEAM_AVAILABILITY"] = "teamAvailability";
  ConditionField["OUTBOUND_SESSION"] = "outboundSession";
  ConditionField["OUTBOUND_REP"] = "autoAssigneeId";
  ConditionField["COUNTRY"] = "geoCountryCode";
  ConditionField["STATE"] = "geoState";
  ConditionField["CANADIAN_PROVINCE"] = "geoCanadianProvince";
  ConditionField["GERMAN_STATE"] = "geoGermanState";
  ConditionField["IP_ADDRESS"] = "geoIp";
  ConditionField["POSTAL_CODE"] = "geoPostalCode";
  ConditionField["DEVICE"] = "device";
  ConditionField["SITE_VISITS"] = "siteVisits";
  ConditionField["DAYS_SINCE_LAST_VISIT"] = "daysSinceLastVisit";
  ConditionField["URL"] = "url";
  ConditionField["URL_PATH"] = "urlPath";
  ConditionField["URL_HOST"] = "urlHost";
  ConditionField["URL_QUERY"] = "urlQuery";
  ConditionField["COOKIE"] = "cookie";
  ConditionField["SCROLL_PERCENTAGE"] = "scrollPct";
  ConditionField["SECONDS_ON_PAGE"] = "secondsOnPage";
  ConditionField["SECONDS_ON_SITE"] = "secondsOnSite";
  ConditionField["REFERRER"] = "referrer";
  ConditionField["WIDGET_STATUS"] = "online";
  ConditionField["EXIT_INTENT"] = "exitIntent";
  ConditionField["CLEARBIT_NAME"] = "clearbit_name";
  ConditionField["CLEARBIT_DOMAIN"] = "clearbit_domain";
  ConditionField["CLEARBIT_REVENUE"] = "clearbit_revenue";
  ConditionField["CLEARBIT_TAGS"] = "clearbit_tags";
  ConditionField["CLEARBIT_TAGS_COMPANY"] = "clearbit_tags_company";
  ConditionField["CLEARBIT_TECH"] = "clearbit_tech";
  ConditionField["CLEARBIT_EMPLOYEES"] = "clearbit_employees";
  ConditionField["CLEARBIT_RAISED"] = "clearbit_raised";
  ConditionField["CLEARBIT_ALEXA_US"] = "clearbit_alexa_us";
  ConditionField["CLEARBIT_ALEXA_GLOBAL"] = "clearbit_alexa_global";
  ConditionField["CLEARBIT_HEADQUARTERS_STATE"] = "clearbit_state";
  ConditionField["CLEARBIT_HEADQUARTERS_COUNTRY"] = "clearbit_country";
  ConditionField["CLEARBIT_HEADQUARTERS_POSTAL_CODE"] = "clearbit_postal_code";
  ConditionField["DEMANDBASE_AUDIENCE"] = "demandbase_audience";
  ConditionField["DEMANDBASE_WATCHLIST"] = "demandbase_watchlist";
  ConditionField["DEMANDBASE_COMPANY_NAME"] = "demandbase_company_name";
  ConditionField["DEMANDBASE_INDUSTRY"] = "demandbase_industry";
  ConditionField["DEMANDBASE_EMPLOYEE_COUNT"] = "demandbase_employee_count";
  ConditionField["DEMANDBASE_EMPLOYEE_RANGE"] = "demandbase_employee_range";
  ConditionField["DEMANDBASE_CITY"] = "demandbase_city";
  ConditionField["DEMANDBASE_STATE"] = "demandbase_state";
  ConditionField["DEMANDBASE_COUNTRY_CODE"] = "demandbase_country_code";
  ConditionField["DEMANDBASE_MARKETING_ALIAS"] = "demandbase_marketing_alias";
  ConditionField["DEMANDBASE_SUB_INDUSTRY"] = "demandbase_sub_industry";
  ConditionField["DEMANDBASE_ANNUAL_SALES"] = "demandbase_annual_sales";
  ConditionField["DEMANDBASE_REVENUE_RANGE"] = "demandbase_revenue_range";
  ConditionField["DEMANDBASE_COUNTRY_NAME"] = "demandbase_country_name";
  ConditionField["MADKUDU_SCORE"] = "madkudu_score";
  ConditionField["TARGET_ACCOUNT"] = "targetAccount";
  ConditionField["CONTACT_SEGMENT"] = "contactSegment";
  ConditionField["CONTACT_SEGMENT_MARKETO"] = "contactSegment_marketo";
  ConditionField["ACCOUNT_SEGMENT"] = "accountSegment";
  ConditionField["INBOX"] = "inboxId";
  ConditionField["END_USER_ATTRIBUTE"] = "contactSegment_endUserAttribute";
  ConditionField["SIXSENSE_SEGMENT_ID"] = "sixSense_segment_id";
})(ConditionField = exports.ConditionField || (exports.ConditionField = {}));